// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    box-sizing: border-box;
  
}
.dashContainer {
  padding: 20px;
  overflow: hidden;
}

.ScorecardsContainer {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.scorecard {
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  padding: 20px;
  border: 2px solid rgb(213, 217, 213);
}

.scorecardheader {
  font-size: 1.2rem;
  color: #555;
  margin-bottom: 10px;
}

.scorecardvalue h1 {
  font-size: 2.5rem;
  color: #333;
}

.ChartsContainer {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  overflow: hidden;
    
}

.chartWrapper {
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  overflow: hidden;
  height: 100%;
  width: 100%;
  
}

.chartWrapper h4 {
  margin-bottom: 20px;
  font-size: 1.5rem;
  color: #555;
}

/* 
.overflower{
    overflow: hidden;
    background-color: red;
} */

/* 
*{
    box-sizing: border-box;
}

.ScorecardsContainer{
    display: flex;
    column-gap: 10px;
  
    width: 100%;
}

.scorecard{
    flex : 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    
    border-radius: 3px;
    border: 2px solid rgb(213, 217, 213);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); 
    padding-bottom: 20px;
    cursor: pointer;
}
.scorecard h1{
   
    font-size: 3rem;
    margin: 0;
    
}

.SecondChartContainer{
    display: flex;
   
}

.firstname{
    flex: 2;
    overflow: hidden;
}

.chartOne{
    height: 500px;
    overflow: hidden;
} */`, "",{"version":3,"sources":["webpack://./src/Components/Applicants/Applicants.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;;AAE1B;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;;AAElB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,WAAW;;AAEb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;;GAIG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA4CG","sourcesContent":["*{\n    box-sizing: border-box;\n  \n}\n.dashContainer {\n  padding: 20px;\n  overflow: hidden;\n}\n\n.ScorecardsContainer {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 20px;\n  margin-bottom: 40px;\n}\n\n.scorecard {\n  background-color: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  padding: 20px;\n  border: 2px solid rgb(213, 217, 213);\n}\n\n.scorecardheader {\n  font-size: 1.2rem;\n  color: #555;\n  margin-bottom: 10px;\n}\n\n.scorecardvalue h1 {\n  font-size: 2.5rem;\n  color: #333;\n}\n\n.ChartsContainer {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 30px;\n  overflow: hidden;\n    \n}\n\n.chartWrapper {\n  background-color: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n  \n}\n\n.chartWrapper h4 {\n  margin-bottom: 20px;\n  font-size: 1.5rem;\n  color: #555;\n}\n\n/* \n.overflower{\n    overflow: hidden;\n    background-color: red;\n} */\n\n/* \n*{\n    box-sizing: border-box;\n}\n\n.ScorecardsContainer{\n    display: flex;\n    column-gap: 10px;\n  \n    width: 100%;\n}\n\n.scorecard{\n    flex : 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    \n    border-radius: 3px;\n    border: 2px solid rgb(213, 217, 213);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); \n    padding-bottom: 20px;\n    cursor: pointer;\n}\n.scorecard h1{\n   \n    font-size: 3rem;\n    margin: 0;\n    \n}\n\n.SecondChartContainer{\n    display: flex;\n   \n}\n\n.firstname{\n    flex: 2;\n    overflow: hidden;\n}\n\n.chartOne{\n    height: 500px;\n    overflow: hidden;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
